import _toConsumableArray from "/codebuild/output/src4209893966/src/www/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/codebuild/output/src4209893966/src/www/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/codebuild/output/src4209893966/src/www/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/codebuild/output/src4209893966/src/www/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["open", "onClose", "initialFocus", "__demoMode"];
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import u, { createContext as ae, createRef as se, useContext as V, useEffect as F, useMemo as h, useReducer as pe, useRef as I, useState as de } from "react";
import { match as k } from "../../utils/match.js";
import { forwardRefWithAs as A, render as E, Features as K } from "../../utils/render.js";
import { useSyncRefs as b } from "../../hooks/use-sync-refs.js";
import { Keys as ue } from "../keyboard.js";
import { isDisabledReactIssue7711 as fe } from "../../utils/bugs.js";
import { useId as C } from "../../hooks/use-id.js";
import { FocusTrap as O } from "../../components/focus-trap/focus-trap.js";
import { useInertOthers as ge } from "../../hooks/use-inert-others.js";
import { Portal as x } from "../../components/portal/portal.js";
import { ForcePortalRoot as H } from "../../internal/portal-force-root.js";
import { Description as ce, useDescriptions as Te } from "../description/description.js";
import { useOpenClosed as me, State as q } from "../../internal/open-closed.js";
import { useServerHandoffComplete as De } from "../../hooks/use-server-handoff-complete.js";
import { StackProvider as Pe, StackMessage as z } from "../../internal/stack-context.js";
import { useOutsideClick as ye } from "../../hooks/use-outside-click.js";
import { getOwnerDocument as Re } from "../../utils/owner.js";
import { useOwnerDocument as he } from "../../hooks/use-owner.js";
import { useEventListener as ve } from "../../hooks/use-event-listener.js";
import { Hidden as Ae, Features as Ee } from "../../internal/hidden.js";
import { useEvent as S } from "../../hooks/use-event.js";
var be = function (t) {
    return t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t;
  }(be || {}),
  Ce = function (e) {
    return e[e.SetTitleId = 0] = "SetTitleId", e;
  }(Ce || {});
var Oe = _defineProperty({}, 0, function _(i, e) {
    return i.titleId === e.id ? i : _objectSpread(_objectSpread({}, i), {}, {
      titleId: e.id
    });
  }),
  M = ae(null);
M.displayName = "DialogContext";
function L(i) {
  var e = V(M);
  if (e === null) {
    var t = new Error("<".concat(i, " /> is missing a parent <Dialog /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, L), t;
  }
  return e;
}
function Se(i, e) {
  return k(e.type, Oe, i, e);
}
var Le = "div",
  we = K.RenderStrategy | K.Static,
  Fe = A(function (e, t) {
    var _k;
    var o = e.open,
      n = e.onClose,
      d = e.initialFocus,
      _e$__demoMode = e.__demoMode,
      g = _e$__demoMode === void 0 ? !1 : _e$__demoMode,
      c = _objectWithoutProperties(e, _excluded),
      _de = de(0),
      _de2 = _slicedToArray(_de, 2),
      m = _de2[0],
      D = _de2[1],
      v = me();
    o === void 0 && v !== null && (o = k(v, (_k = {}, _defineProperty(_k, q.Open, !0), _defineProperty(_k, q.Closed, !1), _k)));
    var a = I(new Set()),
      f = I(null),
      J = b(f, t),
      W = I(null),
      P = he(f),
      B = e.hasOwnProperty("open") || v !== null,
      G = e.hasOwnProperty("onClose");
    if (!B && !G) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
    if (!B) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
    if (!G) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
    if (typeof o != "boolean") throw new Error("You provided an `open` prop to the `Dialog`, but the value is not a boolean. Received: ".concat(o));
    if (typeof n != "function") throw new Error("You provided an `onClose` prop to the `Dialog`, but the value is not a function. Received: ".concat(n));
    var s = o ? 0 : 1,
      _pe = pe(Se, {
        titleId: null,
        descriptionId: null,
        panelRef: se()
      }),
      _pe2 = _slicedToArray(_pe, 2),
      y = _pe2[0],
      Q = _pe2[1],
      R = S(function () {
        return n(!1);
      }),
      U = S(function (r) {
        return Q({
          type: 0,
          id: r
        });
      }),
      _ = De() ? g ? !1 : s === 0 : !1,
      w = m > 1,
      $ = V(M) !== null,
      X = w ? "parent" : "leaf";
    ge(f, w ? _ : !1), ye(function () {
      var l, p;
      return [].concat(_toConsumableArray(Array.from((l = P == null ? void 0 : P.querySelectorAll("body > *, [data-headlessui-portal]")) != null ? l : []).filter(function (T) {
        return !(!(T instanceof HTMLElement) || T.contains(W.current) || y.panelRef.current && T.contains(y.panelRef.current));
      })), [(p = y.panelRef.current) != null ? p : f.current]);
    }, R, _ && !w), ve(P == null ? void 0 : P.defaultView, "keydown", function (r) {
      r.defaultPrevented || r.key === ue.Escape && s === 0 && (w || (r.preventDefault(), r.stopPropagation(), R()));
    }), F(function () {
      var j;
      if (s !== 0 || $) return;
      var r = Re(f);
      if (!r) return;
      var l = r.documentElement,
        p = (j = r.defaultView) != null ? j : window,
        T = l.style.overflow,
        le = l.style.paddingRight,
        Y = p.innerWidth - l.clientWidth;
      if (l.style.overflow = "hidden", Y > 0) {
        var ne = l.clientWidth - l.offsetWidth,
          ie = Y - ne;
        l.style.paddingRight = "".concat(ie, "px");
      }
      return function () {
        l.style.overflow = T, l.style.paddingRight = le;
      };
    }, [s, $]), F(function () {
      if (s !== 0 || !f.current) return;
      var r = new IntersectionObserver(function (l) {
        var _iterator = _createForOfIteratorHelper(l),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var p = _step.value;
            p.boundingClientRect.x === 0 && p.boundingClientRect.y === 0 && p.boundingClientRect.width === 0 && p.boundingClientRect.height === 0 && R();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
      return r.observe(f.current), function () {
        return r.disconnect();
      };
    }, [s, f, R]);
    var _Te = Te(),
      _Te2 = _slicedToArray(_Te, 2),
      Z = _Te2[0],
      ee = _Te2[1],
      te = "headlessui-dialog-".concat(C()),
      oe = h(function () {
        return [{
          dialogState: s,
          close: R,
          setTitleId: U
        }, y];
      }, [s, y, R, U]),
      N = h(function () {
        return {
          open: s === 0
        };
      }, [s]),
      re = {
        ref: J,
        id: te,
        role: "dialog",
        "aria-modal": s === 0 ? !0 : void 0,
        "aria-labelledby": y.titleId,
        "aria-describedby": Z
      };
    return u.createElement(Pe, {
      type: "Dialog",
      element: f,
      onUpdate: S(function (r, l, p) {
        var _k2;
        l === "Dialog" && k(r, (_k2 = {}, _defineProperty(_k2, z.Add, function () {
          a.current.add(p), D(function (T) {
            return T + 1;
          });
        }), _defineProperty(_k2, z.Remove, function () {
          a.current.add(p), D(function (T) {
            return T - 1;
          });
        }), _k2));
      })
    }, u.createElement(H, {
      force: !0
    }, u.createElement(x, null, u.createElement(M.Provider, {
      value: oe
    }, u.createElement(x.Group, {
      target: f
    }, u.createElement(H, {
      force: !1
    }, u.createElement(ee, {
      slot: N,
      name: "Dialog.Description"
    }, u.createElement(O, {
      initialFocus: d,
      containers: a,
      features: _ ? k(X, {
        parent: O.features.RestoreFocus,
        leaf: O.features.All & ~O.features.FocusLock
      }) : O.features.None
    }, E({
      ourProps: re,
      theirProps: c,
      slot: N,
      defaultTag: Le,
      features: we,
      visible: s === 0,
      name: "Dialog"
    })))))))), u.createElement(Ae, {
      features: Ee.Hidden,
      ref: W
    }));
  }),
  ke = "div",
  Me = A(function (e, t) {
    var _L = L("Dialog.Overlay"),
      _L2 = _slicedToArray(_L, 1),
      _L2$ = _L2[0],
      o = _L2$.dialogState,
      n = _L2$.close,
      d = b(t),
      g = "headlessui-dialog-overlay-".concat(C()),
      c = S(function (a) {
        if (a.target === a.currentTarget) {
          if (fe(a.currentTarget)) return a.preventDefault();
          a.preventDefault(), a.stopPropagation(), n();
        }
      }),
      m = h(function () {
        return {
          open: o === 0
        };
      }, [o]);
    return E({
      ourProps: {
        ref: d,
        id: g,
        "aria-hidden": !0,
        onClick: c
      },
      theirProps: e,
      slot: m,
      defaultTag: ke,
      name: "Dialog.Overlay"
    });
  }),
  _e = "div",
  Ie = A(function (e, t) {
    var _L3 = L("Dialog.Backdrop"),
      _L4 = _slicedToArray(_L3, 2),
      o = _L4[0].dialogState,
      n = _L4[1],
      d = b(t),
      g = "headlessui-dialog-backdrop-".concat(C());
    F(function () {
      if (n.panelRef.current === null) throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
    }, [n.panelRef]);
    var c = h(function () {
      return {
        open: o === 0
      };
    }, [o]);
    return u.createElement(H, {
      force: !0
    }, u.createElement(x, null, E({
      ourProps: {
        ref: d,
        id: g,
        "aria-hidden": !0
      },
      theirProps: e,
      slot: c,
      defaultTag: _e,
      name: "Dialog.Backdrop"
    })));
  }),
  xe = "div",
  He = A(function (e, t) {
    var _L5 = L("Dialog.Panel"),
      _L6 = _slicedToArray(_L5, 2),
      o = _L6[0].dialogState,
      n = _L6[1],
      d = b(t, n.panelRef),
      g = "headlessui-dialog-panel-".concat(C()),
      c = h(function () {
        return {
          open: o === 0
        };
      }, [o]),
      m = S(function (a) {
        a.stopPropagation();
      });
    return E({
      ourProps: {
        ref: d,
        id: g,
        onClick: m
      },
      theirProps: e,
      slot: c,
      defaultTag: xe,
      name: "Dialog.Panel"
    });
  }),
  We = "h2",
  Be = A(function (e, t) {
    var _L7 = L("Dialog.Title"),
      _L8 = _slicedToArray(_L7, 1),
      _L8$ = _L8[0],
      o = _L8$.dialogState,
      n = _L8$.setTitleId,
      d = "headlessui-dialog-title-".concat(C()),
      g = b(t);
    F(function () {
      return n(d), function () {
        return n(null);
      };
    }, [d, n]);
    var c = h(function () {
      return {
        open: o === 0
      };
    }, [o]);
    return E({
      ourProps: {
        ref: g,
        id: d
      },
      theirProps: e,
      slot: c,
      defaultTag: We,
      name: "Dialog.Title"
    });
  }),
  mt = Object.assign(Fe, {
    Backdrop: Ie,
    Panel: He,
    Overlay: Me,
    Title: Be,
    Description: ce
  });
export { mt as Dialog };